<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row justify-center items-center col-span-full"
    >
      <section
        class="flex justify-center  w-full lg:w-1/2 bg-gray-500 text-white pt-12 xl:py-12"
        :class="banner.textSectionStyle"
      >
        <section class="max-w-md md:max-w-full md:pl-10  lg:pr-72px xl:max-w-133.25 xl:pr-0 xl:pl-0">
          <p class="text-3xl md:max-w-100 lg:max-w-133.25 md:mr-48 lg:mr-0 xl:pr-32 md:pl-0 pl-10 " v-text="banner.title" :class="banner.titleStyle"
          />
          <ul class="flex flex-col gap-y-8 text-lg pt-8 list-disc pl-70px md:pl-30px xl:pr-20 lg:pr-0 pr-10">
            <li class="max-w-66.75 md:max-w-full" v-text="banner.firstText " :class="banner.textsStyle"
            />
            <li class="max-w-66.75 md:max-w-full" v-text="banner.secondText" :class="banner.textsStyle"
            />
            <li class="max-w-66.75 md:max-w-full" v-text="banner.thirdText" :class="banner.textsStyle"
            />
          </ul>
          <section @click="toTop" class="pt-8 px-4 flex justify-center lg:justify-start">
            <main-button :text="banner.buttonText"  v-if="banner.Button" class=" text-red-400" :class="banner.buttonStyles" />
          </section>
        </section>
      </section>
      <section v-if="!withBorder"  class="h-115.5 banner lg:h-full w-full lg:w-1/2 bg-cover bg-no-repeat"/>
      <img v-if="withBorder"  class="h-115.5 lg:h-full w-full lg:w-1/2 bg-cover bg-gray-400"/>
    </section>
  </section>
</template>
<script>
import MainButton from "../components/MainButton.vue";
export default {
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  components: {
    MainButton,
  },
  methods: {

     handleScroll: function () {
          if (this.scTimer) return;
          this.scTimer = setTimeout(() => {
            this.scY = window.scrollY;
            clearTimeout(this.scTimer);
            this.scTimer = 0;
          }, 100);
     },
     toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
     }
  },
  props:{
    withBorder: {
      default: true
    }, 
    arrowButton:{
      default: false
    },
    imageName:{
      default: null
    },
    banner:{
      default: null 
    },
  }
};
</script>
<style>
ul li::marker {
  font-size: 1.5rem;
}
.banner{
  background-image: url("../assets/images/tertiaryBanner.webp") ;
}
</style>